module.exports = __webpack_public_path__ + "static/media/9H.139c2143.svg";